import { CatchAnimBase } from "./AnimBase";
import { GoalieCatchAnim } from "./Goalie";


/**
 * Vysoky skok do strany s posunem na X a Y
 */
export class Anim3 extends CatchAnimBase {
    /**
     * Cas od zacatku animace, kdy je mozne zahajit pohyb
     */
    private static readonly MOVE_START_TIME = 18 / 30;
    /**
     * Cas od zacatku animace, kdy musi byt dokoncen vertikalni pohyb
     */
    private static readonly VER_MOVE_END_TIME = 40 / 30;
    /**
     * Max vzdalenost pro vertikalni pohyb
     */
    private static readonly VER_MOVE_MAX_DIS = 0.5;

    private static readonly HOR_MOVE_PEEK_TIME = 28 / 30;
    private static readonly HOR_MOVE_END_TIME = 32 / 30;

    private static readonly FLAG_START_VER_MOVE = 2;
    private static readonly FLAG_VER_MOVE = 4;
    private static readonly FLAG_START_HOR_MOVE = 8;
    private static readonly FLAG_HOR_MOVE = 16;

    /**
     * Vzdalenost vertikalni presunu
     */
    private _verMoveDis: number;
    /**
     * Vzdalenost horizontalniho presunu
     */
    private _horMoveDis: number;
    /**
     * Pocatecni pozice brankare na ose X
     */
    private _goalieStartX: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(ballPos: pc.Vec2, ballTime: number, data: GoalieCatchAnim): void {
        this._flags = 0;

        // Cas spusteni animace
        this._animStartTime = ballTime - data.animTimeOffset;

        // Horizontalni posun pres "side step" animaci
        let goaliePos = this._goalie.entity.getPosition();
        let hDis = ballPos.x - goaliePos.x;
        let hDir = hDis < 0 ? -1 : 1;
        let noMoveZoneX = goaliePos.x + data.noHMoveZone.originX * hDir;

        this._horMoveDis = 0;

        if (ballPos.x < noMoveZoneX - data.noHMoveZone.halfWidth || ballPos.x > noMoveZoneX + data.noHMoveZone.halfWidth) {
            // Horizontalni posun behem letu
            this._horMoveDis = ballPos.x - (noMoveZoneX + data.noHMoveZone.halfWidth * hDir);
            this._goalieStartX = goaliePos.x;
            this._flags |= Anim3.FLAG_START_HOR_MOVE;
        }

        // Vertikalni posun brankare behem letu
        if (data.noVMove == undefined || data.noVMove == false) {
            let catchArea = data.catchAreas[0];

            if ((this._verMoveDis = Math.max(0, ballPos.y - (catchArea.y + catchArea.w / 2 - Anim3.VER_MOVE_MAX_DIS))) != 0)
                this._flags |= Anim3.FLAG_START_VER_MOVE;
        }
        else {
            this._verMoveDis = 0;
        }

        // Jmeno animace
        this._animName = data.animName + (hDis > 0 ? "L" : "R");
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        super.update();

        if ((this._flags & CatchAnimBase.FLAG_ANIM_RUNNING) != 0 && (this._flags & (Anim3.FLAG_START_VER_MOVE | Anim3.FLAG_START_HOR_MOVE | Anim3.FLAG_VER_MOVE | Anim3.FLAG_HOR_MOVE)) != 0) {
            let entity = this._goalie.entity;
            let animTime = entity.animation.currentTime;

            if (animTime >= Anim3.MOVE_START_TIME && (this._flags & (Anim3.FLAG_START_VER_MOVE | Anim3.FLAG_START_HOR_MOVE)) != 0) {
                this._flags &= ~(Anim3.FLAG_START_VER_MOVE | Anim3.FLAG_START_HOR_MOVE);

                if (this._horMoveDis != 0)
                    this._flags |= Anim3.FLAG_HOR_MOVE;

                if (this._verMoveDis != 0)
                    this._flags |= Anim3.FLAG_VER_MOVE;
            }

            if ((this._flags & (Anim3.FLAG_VER_MOVE | Anim3.FLAG_HOR_MOVE)) != 0) {
                let progress: number;
                let pos = entity.getPosition();

                if ((this._flags & Anim3.FLAG_VER_MOVE) != 0) {
                    // Vertikalni posun
                    progress = (animTime - Anim3.MOVE_START_TIME) / (Anim3.VER_MOVE_END_TIME - Anim3.MOVE_START_TIME);

                    if (progress > 1) {
                        progress = 1;
                        this._flags &= ~Anim3.FLAG_VER_MOVE;
                    }

                    if (progress < 0.5) {
                        pos.y = this._verMoveDis * (progress / 0.5);
                    }
                    else {
                        pos.y = this._verMoveDis - this._verMoveDis * ((progress - 0.5) / 0.5);
                    }
                }

                if ((this._flags & Anim3.FLAG_HOR_MOVE) != 0) {
                    // Horizontalni posun
                    if (animTime > Anim3.HOR_MOVE_END_TIME) {
                        this._flags &= ~Anim3.FLAG_HOR_MOVE;
                    }
                    else {
                        progress = (animTime - Anim3.MOVE_START_TIME) / (Anim3.HOR_MOVE_PEEK_TIME - Anim3.MOVE_START_TIME);
                        pos.x = this._goalieStartX + this._horMoveDis * progress;
                    }
                }

                entity.setPosition(pos);
            }
        }
    }
}